import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { ApiGet, ApiPut, ApiDelete, ApiPost } from "../../../helpers/API/ApiData";
import axios from "axios";
import { customStyles } from "../tableStyle";
import { TailSpin } from "react-loader-spinner";
import "./contactUs.scss";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { Trash } from "react-feather";
import { Button } from "reactstrap";
import Select from "react-select";
import moment from "moment";
import "moment-timezone";
import { Modal } from "react-bootstrap";
import AddLeadDetails from "../Stepper/addNewLead/AddLeadDetails";
import { getUserInfo } from "../../../utils/user.util";

export default function ContactUSPage() {
  const [getNewsData, setGetNewsData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [countPerPage, setCountPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [countForModel, setCountForModel] = useState(0);
  const [close, setclose] = useState("");
  const [image, setimage] = useState("");
  const [fileType, setfileType] = useState("");
  const [loading, setLoading] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue, 900);
  const [filterData, setFilterData] = useState({});
  const [search, setSearch] = useState();
  const [newpage, setNewPage] = useState(1);
  const [limit, setLimit] = useState(10);
 

 
  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(page - 1) * countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Name der Firma</span>,
      width: "250px",
      selector: (row) => {

        return <div >{row.company_name ? row.company_name : "-"}</div>;
      },
    },
    {
      name: <span>Datum </span>,
      minWidth: "200px",
      selector: (row) => <div className="profileImage">{row.createdAt ? <Moment format="DD-MM-YYYY , HH:mm:ss" tz="CET" date={row.createdAt} /> : "-"}</div>,
    },
    {
      name: "Ansprechpartner",
      width: "250px",
      selector: (row) => <div className="profileImage">{row.contact_person ? row.contact_person : "-"}</div>,
    },
    {
      name: "E-mail",
      width: "300px",
      selector: (row) => <div className="profileImage">{row.email ? row.email : "-"}</div>,
    },

    {
      name: "Anfragekategorie",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.inquiryCategory ? row.inquiryCategory : "-"}</div>,
    },

    {
      name: "Region",
      width: "200px",
      selector: (row) => <div className="profileImage">{row.region ? row.region : "-"}</div>,
    },

    {
      minWidth: "200px",
      name: "Telephone",
      selector: (row) => (
        <div className="profileImage" style={{ "white-space": "normal" }}>
          {row.telephone ? row.telephone : "-"}
        </div>
      ),
    },
    {
      minWidth: "150px",
      name: "Aktion",
      selector: (row) => (
        <div className="actionColumn">

          <Button
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => {
              handleConfirmDelete(row);
            }}
          >
            <Trash className="font-medium-2" />
          </Button>
        </div>
      ),
    },
  ];
  const handleDeleteNewsInfo = async (row) => {
    setLoading(true);
    let response = false;
    await ApiDelete(`inquiry/deleteInquiry?id=${row?._id}`)
      .then((res) => {
        setLoading(false);
        handleChangeCommom("", "", filterData);
        response = true;
      })
      .catch((err) => {
        setLoading(false);
      });
    return response;
  };

  const handleConfirmDelete = (row) => {
    return Swal.fire({
      title: "Bist du sicher?",
      text: "Möchten Sie diese Abfrage wirklich löschen?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ja, löschen",
      cancelButtonText: "Abbrechen",
      customClass: {
        confirmButton: "btn btn-primary mr-10",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async function (result) {
      if (result.value) {
        const res = await handleDeleteNewsInfo(row);
        if (res) {
          Swal.fire({
            icon: "success",
            title: "Gelöscht!",
            text: "Die Lead wurde gelöscht.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          Swal.fire({
            title: "Abgesagt",
            text: "Löschung abgebrochen!!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        Swal.fire({
          title: "Abgesagt",
          text: "Löschung abgebrochen!!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    });
  };

 

  useEffect(() => {
    handleChangeCommom("", "", filterData);
  }, [debouncedSearchValue, page, countPerPage]);



  const handleChangeCommom = async (e, key, filter) => {
    let updatedFilter = { ...filterData };

    if (!e && key) {

      if (key === "startDate" || key === "endDate") {
        updatedFilter.startDate = "";
        updatedFilter.endDate = "";
      } else {
        updatedFilter[key] = "";
      }
    } else {
      if (key == "userId") {
        updatedFilter = {
          ...filterData,
          [`${key}[]`]: e.map((item) => item.value),
        };
      } else {
        updatedFilter = key ? { ...filterData, [key]: e.label } : filter;
      }
    }

    setLoading(true);
    let ddd = "";
    for (const [key, value] of Object.entries(updatedFilter)) {
      if (Array?.isArray(value)) {
        for (const v of value) {
          ddd += `${key}=${v}&`;
        }
      } else if (value) {
        const data = encodeURIComponent(value);
        ddd += `${key}=${data}&`;
      }
    }

    try {
      const response = await ApiGet(`inquiry/getInquiry?limit=${countPerPage}&page=${page}${debouncedSearchValue ? `&search=${searchValue}` : ""}`);
      const data = response?.data?.payload.data;
      setCount(response?.data?.payload.count);
      setGetNewsData(data);
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }

    setFilterData(updatedFilter);
  };

  const customNoDataComponent = () => <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>Aktuell sind keine Daten vorhanden.</div>;

  const getUserData = async () => {
    await ApiGet(`user/get?page=${newpage}&limit=${limit}${search ? `&search=${search}` : ""}`)
      .then((response) => {
        const data = response?.data?.payload.data;
        setCountForModel(response?.data?.payload.count / 10);
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  useEffect(() => {
    getUserData();
  }, [newpage, limit, search]);

  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3" style={{display:"flex", justifyContent:"space-between", padding:"0 20px"}}>
              <h2 className="pt-2 mr-5" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>Kontakt</h2>

                  <div className="pt-2 mr-5"> 
                    <input
                      type="search"
                      className={`form-control form-control-lg form-control-solid `}
                      onChange={(e) => {
                        setSearchValue(e.target.value);
                        setLoading(true);
                      }}
                      name="search"
                      value={searchValue}
                      placeholder="Suche"
                    />
                  </div>

          </div>
          <DataTable
            data={getNewsData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              setCountPerPage(rowPerPage);
            }}
            fixedHeader
          />
        </div>
      </div>

      {close && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setclose(!close);
                  setimage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              {fileType == "svg" || fileType == "png" || fileType == "jpg" || fileType == "jpeg" ? (
                <>
                  <img className="modal-image" src={image} />
                </>
              ) : fileType === "pdf" ? (
                <>
                  <object data={image} type="application/pdf" width="420px" height="650px"></object>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}

      
    </div>
  );
}
